import React from 'react';

import PropTypes from 'prop-types';
import { ResponsiveContainer, CartesianGrid, Tooltip, XAxis, YAxis, Text, Area, AreaChart } from 'recharts';

import theme from 'constants/theme';

const AxisLabel = ({ axisType, value, viewBox }) => {
  const { x, y, width, height } = viewBox;
  const isVert = axisType === 'yAxis';
  const defaultOffset = 15;

  const cx = isVert ? x + defaultOffset : x + width / 2;
  const cy = isVert ? height / 2 + y : y + height + defaultOffset;

  return (
    <Text x={cx} y={cy} angle={isVert ? -90 : 0} textAnchor="middle">
      {value}
    </Text>
  );
};

const CustomLabel = (props) => {
  const { fill, x, y, value, width, height } = props;

  return (
    <text x={x + width / 2} y={y - 5} fill={fill} textAnchor="middle">
      {value}
    </text>
  );
};

const MeshAreaChart = ({
  data,
  chartProps = {
    width: '100%',
    height: '100%',
  },
  xAxisLabelProps,
  yAxisLabelProps,
}) => (
  <ResponsiveContainer width={chartProps.width} height={chartProps.height} aspect={chartProps.aspectRatio}>
    <AreaChart
      data={data}
      margin={{
        top: 20,
        left: yAxisLabelProps?.value ? 20 : 0,
        bottom: xAxisLabelProps?.value ? 30 : 0,
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis
        dataKey="displayName"
        stroke={theme.palette.background.lightGrey3}
        tick={{ fill: theme.palette.text.secondary }}
        label={xAxisLabelProps?.value ? <AxisLabel axisType="xAxis" value={xAxisLabelProps.value} /> : null}
      />
      <YAxis
        stroke={theme.palette.background.lightGrey3}
        tick={{ fill: theme.palette.text.secondary }}
        label={yAxisLabelProps?.value ? <AxisLabel axisType="yAxis" value={yAxisLabelProps.value} /> : null}
      />
      <Tooltip />
      <Area
        type="monotone"
        dataKey="count"
        stroke={theme.palette.primary.main}
        fill={theme.palette.background.lightBlue}
      />
    </AreaChart>
  </ResponsiveContainer>
);

MeshAreaChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number]).isRequired,
      color: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  chartProps: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string,
    aspectRatio: PropTypes.number,
  }),
  xAxisLabelProps: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }),
  yAxisLabelProps: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }),
};

export default MeshAreaChart;
